import classNames from "classnames";

const Checkbox = props => {
  const {
    options = [],
    label,
    error,
    formik,
    onChange,
    singleSelection,
    value,
    singleCheckbox,
    onBlur,
    disabled,
    className,
    submitOnChangeFunc,
    uncheckedValue = 0,
  } = props;
  const changeValues = (e, value) => {
    const event = { ...e };
    if (singleCheckbox) {
      formik &&
        formik.setFieldValue(
          props.name,
          !event.target.checked ? uncheckedValue : value,
        );
    } else {
      onChange?.(event);
    }
  };

  return (
    <div className="flex flex-col flex-grow">
      {label && (
        <span className="block text-xs font-medium text-black">{label}</span>
      )}
      <fieldset className={`mt-1 space-y-5 ${className}`}>
        {options?.map((item, key) => {
          const isChecked = `${item.value}` === `${value}`;
          const checkboxClasses = classNames(
            "focus:ring-0 h-4 w-4 text-gray-800 border-gray-800 border-2 rounded",
            { "opacity-50 cursor-not-allowed": disabled },
            { "bg-gray-300": disabled },
          );
          return (
            <div className="relative flex items-start mt-2" key={key}>
              <div className="flex h-5 items-center">
                <input
                  id={props.name}
                  value={item.value}
                  checked={isChecked}
                  aria-describedby="comments-description"
                  name={props.name}
                  type={singleSelection ? "radio" : "checkbox"}
                  className={checkboxClasses}
                  onChange={async e => {
                    changeValues(e, item.value);
                    await submitOnChangeFunc();
                  }}
                  onBlur={onBlur}
                  disabled={disabled}
                />
              </div>
              {item?.label && (
                <div className="ml-2 text-sm">
                  <label
                    htmlFor={props.name}
                    className="text-xs text-gray-700"
                  >
                    {item?.label}
                  </label>
                </div>
              )}
            </div>
          );
        })}
        {error && <small className="text-sm text-red-600">{error}</small>}
      </fieldset>
    </div>
  );
};

export default Checkbox;
